import { Navigate } from "react-router-dom";
import { SafeOutlet } from "@/shared/components/ErrorBoundary";
import { useClinicianAuthStore } from "@/stores/clinicianAuthStore";
import { useClinicianSocket } from "@/lib/clinicianSocket";
import { useIdleLogout } from "@/portals/clinician/hooks/useIdleLogout";
import { PageSpinner } from "@/shared/components/spinner";
import { AppQueryProvider } from "@/lib/query/AppQueryProvider";
import { useClinicianLiveQueries } from "@/portals/clinician/api/clinicianQueries";
import { ClinicianLayout } from "./ClinicianLayout";

function SessionLoader() {
  return (
    <div className="bg-white">
      <PageSpinner fullScreen />
    </div>
  );
}

/** Socket events → cache invalidation, for as long as the session lasts. */
function ClinicianLiveQueries() {
  useClinicianLiveQueries();
  return null;
}

export function ClinicianProtectedLayout() {
  const isAuthenticated = useClinicianAuthStore((s) => s.isAuthenticated);
  const isLoading = useClinicianAuthStore((s) => s.isLoading);
  useIdleLogout();
  useClinicianSocket();

  if (isLoading) return <SessionLoader />;
  if (!isAuthenticated) return <Navigate to="/clinician/login" replace />;

  // Server-data cache for this session only — unmounted (and emptied) on logout.
  return (
    <AppQueryProvider>
      <ClinicianLiveQueries />
      <ClinicianLayout>
        <SafeOutlet />
      </ClinicianLayout>
    </AppQueryProvider>
  );
}
